
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook to detect if diagnostic mode should be enabled
 * Can be activated via URL parameter '?diagnostics=true'
 */
export function useDiagnosticMode(): {
  isDiagnosticMode: boolean;
  toggleDiagnosticMode: () => void;
} {
  const [isDiagnosticMode, setIsDiagnosticMode] = useState<boolean>(false);
  const location = useLocation();
  
  useEffect(() => {
    // Check URL parameters for diagnostic mode
    const searchParams = new URLSearchParams(location.search);
    const diagnosticsParam = searchParams.get('diagnostics');
    
    if (diagnosticsParam === 'true') {
      setIsDiagnosticMode(true);
      console.log('[Diagnostics] Mode enabled via URL parameter');
    } else {
      // Also check local storage for persistent preference
      const storedPreference = localStorage.getItem('lamulamu_diagnostics_enabled');
      if (storedPreference === 'true') {
        setIsDiagnosticMode(true);
        console.log('[Diagnostics] Mode enabled via stored preference');
      }
    }
  }, [location]);
  
  const toggleDiagnosticMode = () => {
    const newValue = !isDiagnosticMode;
    setIsDiagnosticMode(newValue);
    
    // Store preference in localStorage for persistence
    localStorage.setItem('lamulamu_diagnostics_enabled', newValue ? 'true' : 'false');
    console.log(`[Diagnostics] Mode ${newValue ? 'enabled' : 'disabled'}`);
  };
  
  return { isDiagnosticMode, toggleDiagnosticMode };
}
